import { PropertyType as SrsPropertyType, PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { paraCord } from '../endpoints';
import { ParaCordWrapper } from './wrapper';
import { ParaCordKnobs } from './knobs';
import { ParaCordActions } from "./actions";
import {filterProperties} from "utilities/srsUtils";

const flags = [SrsPropertyFlag.Categorical];
const types = [SrsPropertyType.String];

export const config = {
  key: "PARACORD",
  label: 'ParaCord',
  icon: 'parallel-coordinates',
  wrapper: ParaCordWrapper,
  endpoint: paraCord,
  Knobs: ParaCordKnobs,
  Actions: ParaCordActions,
  flags: flags,
  types: types,
  createDefaultOptions: (filteredProperties) => {
    return {
      options: {
        propertyList: [
          filteredProperties[0].name,
          filteredProperties[1].name,
        ],
        parameters: {
          maxValues: 15
        },
      },
    };
  },
  isValid: (selectedDefinitionName) => {
    return filterProperties(selectedDefinitionName, flags, types).length >= 2;
  },
};
